export const ComeInSlideAnimation = (direction, distance, duration, delay) => {
  return direction === "down"
    ? {
        from: { translateY: `${distance}px`, opacity: 0 },
        to: { translateY: `${distance}px`, opacity: 1 },
        delay: delay,
        config: { duration: duration, tension: 120, friction: 14 },
      }
    : direction === "up"
    ? {
        from: { translateY: `${distance}px`, opacity: 0 },
        to: { translateY: `0px`, opacity: 1 },
        delay: delay,
        config: { duration: duration, tension: 120, friction: 14 },
      }
    : direction === "left"
    ? {
        from: { translateX: `-${distance}px`, opacity: 0 },
        to: { translateX: `0px`, opacity: 1 },
        delay: delay,
        config: { duration: duration, tension: 120, friction: 14 },
      }
    : direction === "right" && {
        from: { translateX: `${distance}px`, opacity: 0 },
        to: { translateX: `0px`, opacity: 1 },
        delay: delay,
        config: { duration: duration, tension: 120, friction: 14 },
      };
};
